import { api } from '@/lib/api-manager'
import type { Curriculum } from '@/types/courses/curriculum'

export async function getAllCurriculumsByCourse(courseId?: string) {
  const response = await api.get('v1/educations/integrations/curriculums', {
    params: { courseId }
  })

  // biome-ignore lint/suspicious/noExplicitAny: <explanation>
  const curriculums: Curriculum[] = response.data.data.map(
    (curriculum: any) => {
      const mapped: Curriculum = {
        id: curriculum.id,
        curriculumID: curriculum.id
      }
      return mapped
    }
  )

  return curriculums
}
